import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';

export default function PlateSamplingLeftBar(props) {
    const classes = useStyles();

    const [bookingSequence, setBookingSequence] = useState(null);
    let totalPallets = 0;

    useEffect(() => {
        dataService.GetBookingSequenceByProductionOrderIdAndBarcode(props.productionOrder.id, props.barcode).then(sequence => {
            if (parseInt(sequence) === -1) {
                setBookingSequence(props.barcode)
            }
            else if (sequence < 9) {
                setBookingSequence("0" + (parseInt(sequence) + 1))
            }
            else {
                setBookingSequence((parseInt(sequence) + 1))
            }
        }).catch((error) => { toast.error(error, { position: "top-center" }) })

    }, [props.productionOrder.id, props.barcode]);

    if (props.productionOrder) {
        if (props.productionOrder.bomOut.length > 0) {
            totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)
        }
    }

    return (
        <div className={classes.container}>
            <div className={classes.title}>Pallet</div>
            <div className={classes.paletContainer}>
                <div className={classes.sequence} style={{ fontSize: bookingSequence === props.barcode ? "13px" : "67px", marginTop: bookingSequence === props.barcode && "15px" }}>{bookingSequence}</div>
                {bookingSequence ? props.barcode === bookingSequence ? <React.Fragment></React.Fragment>
                    :
                    <div className={classes.total}>
                        <div className={classes.content}>{"/" + totalPallets}
                        </div>
                    </div> :
                    <React.Fragment></React.Fragment>}
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        float: "left",
        width: "150px",
        paddingTop: "20px",
        position: "fixed",
        top: "140px",
        height: "100%",
        borderRight: "1px solid #DEDEDE",
    },
    title: {
        color: "#000000",
        fontSize: "21px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium'
    },
    sequence: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        width: "60%",
        float: "left",
        height: "80px"
    },
    total: {
        color: "#000000",
        fontSize: "25px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        width: "40%",
        float: "left",
        height: "80px"
    },
    content: {
        position: "relative",
        top: '40px',
        right: "10px"
    },
    paletContainer: {
        height: "100px",
        borderBottom: "1px solid #DEDEDE"

    },
    vng: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "20px"
    }
});